// Ported from design_handoff_make_your_point/designs/direction-drill.jsx (lines 102-129).
// React-free: highlightJargon returns an HTML string instead of JSX fragments.

export function wordCount(s) {
  const t = (s || "").trim()
  return t ? t.split(/\s+/).filter(Boolean).length : 0
}

export function sentenceStats(s) {
  const t = (s || "").trim()
  if (!t) return { sentences: 0, words: 0, avg: 0 }
  const sentences = t.split(/[.!?]+/).filter((p) => p.trim().length > 0)
  const words = t.split(/\s+/).filter(Boolean).length
  return {
    sentences: sentences.length,
    words,
    avg: sentences.length ? Math.round((words / sentences.length) * 10) / 10 : 0,
  }
}

export function jargonRegex(list) {
  const sorted = list.slice().sort((a, b) => b.length - a.length)
  const escaped = sorted.map((j) => j.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")).join("|")
  return new RegExp("(" + escaped + ")", "gi")
}

export function countJargon(text, list) {
  if (!list || !list.length || !text) return []
  return text.match(jargonRegex(list)) || []
}

function escapeHtml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
}

export function highlightJargon(text, list) {
  if (!list || !list.length || !text) return escapeHtml(text || "")
  const re = jargonRegex(list)
  const lower = new Set(list.map((j) => j.toLowerCase()))
  return text
    .split(re)
    .map((p) =>
      lower.has(p.toLowerCase())
        ? `<mark class="drill-jargon">${escapeHtml(p)}</mark>`
        : escapeHtml(p)
    )
    .join("")
}

export function firstSentence(s) {
  const t = (s || "").trim()
  if (!t) return ""
  const match = t.match(/^[^.!?]+[.!?]?/)
  return match ? match[0].trim() : t
}

export function lineCount(s) {
  return (s || "").split("\n").filter((l) => l.trim().length > 0).length
}
